<template>
  <div class="bto-sb-widget-title">
    <h3>{{name}}</h3>
    <ul class="bto-sb-market-colum">
      <li :class="{'bto-sb-market-colum-active' :!useSingleView }"><a v-on:click="toggleViewMode(false)" v-bind:title="`${t('W.MultiView')}`"></a></li>
      <li :class="{'bto-sb-market-colum-active' :useSingleView }"><a v-on:click="toggleViewMode(true)" v-bind:title="`${t('W.SingleView')}`"></a></li>
    </ul>
    <div class="bto-sb-form-select" v-if="hasFilter">
      <select @change="filterEvents($event)" v-model="selFilterVal">
        <option v-for="(item, index) in filterItems" :key="index" v-bind:value="item.value">
          {{
          `${t('W.Next')} ${item.hours || item.minutes}
          ${item.hours ? t(item.hours > 1 ? t('W.Hours') : t('Global.Hour')) : ''}
          ${item.hours && item.minutes ? item.minutes : ''}
          ${item.minutes ? t('W.Minutes') : ''}`
          }}
        </option>
      </select>
      <div class="bto-sb-form-select-arrow"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'TitleComponent',
    data() {
      return {
        filterItems: [],
        selFilterVal: 0,
        useSingleView: APP_SETTINGS.settings.useLatam,
      };
    },
    props: {
      name: {
        type: String,
        default: () => '',
        required: true,
      },
      hasFilter: {
        type: Boolean,
        default: () => false,
        required: true,
      },
      nextHours: {
        type: String,
        default: '0',
      },
      stepInMinutes: {
        type: String,
        default: '0',
      },
      cashoutVisibility: {
        type: Boolean,
        default: false,
      }
    },
    created() {
      this.createFilter();
      this.toggleViewMode(this.useSingleView);
    },
    methods: {
      createFilter() {
        if (!this.hasFilter) {
          return;
        }
        let maxMinutes = parseInt(this.nextHours, 10) * 60;
        let itemMinutes = parseInt(this.stepInMinutes, 10);
        while (maxMinutes >= parseInt(this.stepInMinutes, 10) && maxMinutes > 0) {
          this.filterItems.push(
            {
              value: itemMinutes, // total minutes
              hours: parseInt(itemMinutes / 60),
              minutes: parseInt(itemMinutes % 60),
            }
          );
          itemMinutes += parseInt(this.stepInMinutes, 10);
          maxMinutes -= parseInt(this.stepInMinutes, 10);
        }
        this.selFilterVal = this.filterItems[0].value;
      },
      filterEvents(event) {
        this.$emit('changeFilter', event.target.value);
        this.selFilterVal = event.target.value;
      },
      toggleViewMode(isSingleMarketView) {
        this.useSingleView = isSingleMarketView;
        this.$emit('toggleViewMode', isSingleMarketView);
      }
    },
  };
</script>
